// extracted by mini-css-extract-plugin
export default {"container":"ManageFundingTiersModal_container__-YELk","dndContainer":"ManageFundingTiersModal_dndContainer__ZlpPc","saveButton":"ManageFundingTiersModal_saveButton__uhHYT"};